import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 62px 1fr;
  gap: 0 30px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    max-width: 200px;
    margin: 0 auto;
    text-align: center;
    display: block;
  }
`;

export const TextContentWrapper = styled.div``;

export const Label = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: block;
  margin-bottom: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    line-height: 25px;
    margin-bottom: 20px;
  }
`;

export const Description = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  opacity: 0.9;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    line-height: 18px;
    display: block;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 63px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }
`;
